import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from './SiteSettingsContext';
import { isExternalHeroActionPath, normalizeHeroActionPath } from './storefrontHeroActions';

function isAnnouncementEnabled(settings) {
  const v = settings?.announcement_enabled;
  return v === true || v === 1 || v === '1';
}

export default function HomeAnnouncementBar() {
  const { settings } = useSiteSettings();

  if (!isAnnouncementEnabled(settings)) return null;
  const text = String(settings.announcement_text || '').trim();
  if (!text) return null;

  const link = normalizeHeroActionPath(settings.announcement_link);
  const message =
    link && !isExternalHeroActionPath(link) ? (
      <Link to={link} className="home-announcement-bar__link">
        {text}
      </Link>
    ) : link ? (
      <a href={link} className="home-announcement-bar__link" target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    ) : (
      <span className="home-announcement-bar__text">{text}</span>
    );

  return (
    <aside className="home-announcement-bar" role="status" aria-live="polite">
      <div className="container home-announcement-bar__inner">
        <span className="home-announcement-bar__badge" aria-hidden="true">
          ✦
        </span>
        {message}
      </div>
    </aside>
  );
}
